import { render, staticRenderFns } from "./AddBankView.vue?vue&type=template&id=68f6f90f"
import script from "./AddBankView.vue?vue&type=script&lang=js"
export * from "./AddBankView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports